import React from "react";
import Reveal from "./reveal";
import CountUp from "./count-up";

/** items = [[value, label], ...] */
export default function StatStrip({ items }) {
  return (
    <Reveal className="stat-strip">
      {items.map(([value, label]) => (
          <div key={label} className="flex flex-col items-center">
          <strong >
            <CountUp  value={value} />
          </strong>
          <span className="text-gray-400 text-sm mt-1">{label}</span>
        </div>
      ))}
    </Reveal>
  );
}
